import type { Scene } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { BaseSceneSwapBridge } from 'js/src/libs/scene-swapping/BaseBridge';
import { isAIAvatarSceneGroup, isTalkingHeadSceneGroup } from 'js/src/luminary';

export class VoiceoverToTalkingHeadInsertBridge extends BaseSceneSwapBridge {
    override _from = VideoData.CATEGORY_VOICEOVER;
    override _to = VideoData.CATEGORY_TALKING_HEAD_INSERT;

    override _isSwapAllowedFor(originalScene: Scene): boolean {
        // you can swap a voiceover scene to an talking head insert scene if the voiceover category scene is being
        // used as an overlay on a talking head or AI avatar scene group
        return (
            isTalkingHeadSceneGroup(originalScene.sceneGroup) ||
            isAIAvatarSceneGroup(originalScene.sceneGroup)
        );
    }
}
